import React from 'react'
import ContactHero from '../../components/ConatctUs/ContactHero'
import SimpleBanner from '../../components/common/SimpleBanner'

const Contact = () => {
  return (
    <div>
      <SimpleBanner title="Contact Us" subheading='Home / Contact Us' />
        <ContactHero/>
    </div>
  )
}

export default Contact